module.exports = __webpack_public_path__ + "static/media/aoc_trading.f71c67aa.svg";